import { useState } from "react";
import { FCX, Tooltip } from "@datassential/platform-ui-lib";
import Page from "@containers/Page/Page";
import PageContent from "@containers/PageContent/PageContent";
import MacsHeader from "./MacsHeader";
import FastestGrowing from "@pages/TrendingNow/FastestGrowing";
import ReadAboutIt from "@pages/TrendingNow/ReadAboutIt";
import PeopleSocialPublication from "@pages/TrendingNow/PeopleSocialPublication";
import MacsListTable from "./MacsList";
import { CustomBaseScrollbars } from "@components/CustomScrollbarsVirtualList/CustomScrollbarsVirtualList";
import { getSectionId } from "@core/helpers";
import useFavicon from "@core/hooks/useFavicon";
import './TrendingNow.scss';
import HeaderInfo from "@pages/TrendingNow/HeaderInfo";
import PeopleSaying from "@pages/TrendingNow/PeopleSaying";
import TrendingNowHeader from "@pages/TrendingNow/TrendingNowHeader";

export const TRENDING_NOW_SCROLLBAR_ID = 'TrendingNowPageScrollbar';
const TRENDING_NOW_NAVIGATION_OFFSET = 90;

const TRENDING_NOW_TABS = [
    { id: 'people', title: 'People' },
    { id: 'mac', title: 'MAC' },
];

const TrendingNow: FCX = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    useFavicon('/trending-now-favicon.ico');

    return (
        /* @ts-ignore */
        <Page className="TrendingNow">
            <PageContent>
                <CustomBaseScrollbars
                    id={TRENDING_NOW_SCROLLBAR_ID}
                    onScroll={(event: any) => {
                        setIsScrolled(event?.target?.scrollTop > 0);
                    }}
                >
                    <TrendingNowHeader
                        tabs={TRENDING_NOW_TABS}
                        containerId={TRENDING_NOW_SCROLLBAR_ID}
                        offset={TRENDING_NOW_NAVIGATION_OFFSET}
                        isScrolled={isScrolled}
                    />
                    <div className="TrendingNow__content" data-testid="blockMacsPage">
                        <div id={getSectionId('people')} className="TrendingNow__sectionBlock">
                            <div className="TrendingNow__title">SOCIAL
                                <div className="divider"/>
                            </div>
                            <div className="TrendingNow__wrapper">
                                <div className="TrendingNow__section">
                                    <HeaderInfo
                                        text="WHAT PEOPLE ARE SAYING"
                                        highlightWord="PEOPLE"
                                        infoTooltipId="what-people-saying-info"
                                    />
                                    <Tooltip id="what-people-saying-info" place="right">
                                        Top trending keywords by 1 month engagement growth
                                    </Tooltip>
                                </div>
                                <div className="TrendingNow__section" data-testid="blockPeopleSayingSection">
                                    <PeopleSaying/>
                                    <PeopleSocialPublication/>
                                </div>
                            </div>
                        </div>
                        <div id={getSectionId('mac')} className="TrendingNow__sectionBlock">
                            <div className="TrendingNow__title">MENU
                                <div className="divider"/>
                            </div>
                            <div className="TrendingNow__wrapper">
                                <div className="TrendingNow__section">
                                    <MacsHeader/>
                                </div>
                                <div className="TrendingNow__section" data-testid="blockMacsWhatsHotSection">
                                    <FastestGrowing/>
                                    <ReadAboutIt/>
                                </div>
                                <div className="TrendingNow__section TrendingNowTableSection">
                                    <MacsListTable/>
                                </div>
                            </div>
                        </div>
                    </div>
                </CustomBaseScrollbars>
            </PageContent>
        </Page>
    );
};

export default TrendingNow;
